(globalThis as any).__RACOON_ENV__ = {
  ...(globalThis as any).__RACOON_ENV__,
  ...import.meta.env,
};
